export default "__VITE_ASSET__BMctXVA3__"